import { useCallback, useState } from 'react';

const STORAGE_KEY = 'usageGranularity';
const VALID_VALUES = ['daily', 'hourly'] as const;
export type UsageGranularity = (typeof VALID_VALUES)[number];

function readStoredGranularity(): UsageGranularity {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored && (VALID_VALUES as readonly string[]).includes(stored)) {
      return stored as UsageGranularity;
    }
  } catch {
    // ignore corrupted storage
  }
  return 'daily';
}

/**
 * Persists the daily/hourly toggle in sessionStorage so the user's choice survives
 * navigation between units and properties within the same browser session — same
 * UX pattern as `usePersistedDateRange`.
 */
export function usePersistedUsageGranularity() {
  const [granularity, setGranularityState] = useState<UsageGranularity>(readStoredGranularity);

  const setGranularity = useCallback((next: UsageGranularity) => {
    sessionStorage.setItem(STORAGE_KEY, next);
    setGranularityState(next);
  }, []);

  return { granularity, setGranularity };
}
